import { useMutation, useQueryClient } from '@tanstack/react-query';

import { startMcpOAuthConnect } from '@/api/v4/mcp-oauth.api';
import { QueryKey } from '@/config/query-client';

export const useMcpOAuthConnect = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: startMcpOAuthConnect,
    onSuccess: async ({ authorizeUrl }) => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.McpOAuthGrants],
      });
      window.location.href = authorizeUrl;
    },
  });

  return {
    connect: mutation.mutateAsync,
    isConnecting: mutation.isPending,
  };
};
